import * as React from 'react';

import { Checkbox, warningIcon, } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';

const UnassignWarningModal = ({ removedStudentCount, toggleCheckbox, closeModal, handleClickUpdate, hideWarningModalInFuture, }) => {
  const { modalRef } = useModalAccessibility(close);

  return (
    <div className="modal-container unassign-warning-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="unassignWarningModalTitle"
        aria-modal="true"
        className="quill-modal unassign-warning-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-body">
          <h2 id="unassignWarningModalTitle"><img alt="" src={warningIcon.src} /> <span>{removedStudentCount} Student{removedStudentCount === 1 ? '' : 's'} Will Have This Activity Pack Removed</span></h2>
          <div className="unassign-warning-modal-text">
            <p>The students will no longer see this activity pack -- <b>they will no longer see their previously completed assignments and their not yet completed assignments.</b><br /><br />You can restore the pack at any point in the future if you would like these students to be able to see their assignments again.<br />If you do not want these students to lose access to this activity pack, click the <b>Cancel</b> button and re-check these students’ names.<br /><br />If you would like to remove the activity pack for these students, click the <b>Update Students</b> button.</p>
          </div>
          <div className="unassign-warning-modal-footer">
            <div className="checkbox-wrapper">
              <Checkbox
                label="Don't show this message again"
                onClick={toggleCheckbox}
                selected={hideWarningModalInFuture}
              />
            </div>
            <div className="buttons">
              <button className="quill-button outlined medium focus-on-light" onClick={closeModal} type="button">Cancel</button>
              <button className="quill-button contained medium focus-on-light" onClick={handleClickUpdate} type="button">Update students</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnassignWarningModal
